export default __webpack_public_path__ + "static/media/economyAtAGlance.e49991cc.jpg";